/**
 * Search Overlay — Premium discover content when search is focused.
 * Shows categories + popular search terms in the flydown area.
 * Works WITH the existing Empire LiveSearch, not against it.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'sk-search-open';
  var backdrop = null;

  function createBackdrop() {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'sk-search-backdrop';
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', close);
    return backdrop;
  }

  function open() {
    createBackdrop();
    document.body.classList.add(OPEN_CLASS);
    requestAnimationFrame(function () {
      backdrop.classList.add('sk-search-backdrop--visible');
    });
    // Show discover content
    var discover = document.querySelector('[data-sk-search-discover]');
    if (discover) discover.style.display = '';
  }

  function close() {
    document.body.classList.remove(OPEN_CLASS);
    if (backdrop) backdrop.classList.remove('sk-search-backdrop--visible');
    // Blur input
    var input = document.querySelector('[data-live-search-input]');
    if (input) input.blur();
  }

  function handlePopularTerm(e) {
    var term = e.target.getAttribute('data-sk-search-term');
    if (!term) return;
    var input = document.querySelector('[data-live-search-input]');
    if (!input) return;
    input.value = term;
    input.focus();
    input.dispatchEvent(new Event('keyup', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    // Hide discover, results will appear
    var discover = document.querySelector('[data-sk-search-discover]');
    if (discover) discover.style.display = 'none';
  }

  function handleVisualHintClick() {
    var vsBtn = document.querySelector('[data-vs-btn]');
    if (vsBtn) vsBtn.click();
  }

  function init() {
    var input = document.querySelector('[data-live-search-input]');
    if (!input) return;

    // Open overlay when search input is focused
    input.addEventListener('focus', function () {
      open();
    });

    // Hide discover when typing, show when empty
    input.addEventListener('input', function () {
      var discover = document.querySelector('[data-sk-search-discover]');
      if (!discover) return;
      discover.style.display = input.value.trim() ? 'none' : '';
    });

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
        close();
      }
    });

    // Popular search terms
    document.querySelectorAll('[data-sk-search-term]').forEach(function (t) {
      t.addEventListener('click', handlePopularTerm);
    });

    // Visual search hint
    var vsHint = document.querySelector('[data-sk-vs-hint]');
    if (vsHint) vsHint.addEventListener('click', handleVisualHintClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
